// SEO content-hub FOUNDATION (architecture only — no articles generated yet).
// Each hub links to the relevant free tool + signup. Ready to attach articles later.
export const CONTENT_HUBS = {
  "business-credit": {
    slug: "business-credit",
    title: "Business Credit",
    metaTitle: "Business Credit Guides",
    metaDescription: "Learn how to build business credit separate from your personal score — guides, checklists, and tools from Fairview Systems.",
    intro: "Everything founders need to build strong business credit — from your D-U-N-S number to net-30 tradelines. In-depth guides are on the way.",
    relatedTools: ["business-structure-recommender"],
  },
  "start-a-business": {
    slug: "start-a-business",
    title: "Start a Business",
    metaTitle: "How to Start a Business",
    metaDescription: "Step-by-step guides to start a business the right way: idea validation, structure, formation, and launch — from Fairview Systems.",
    intro: "From idea to launch: validate your concept, pick the right structure, and get set up correctly. Comprehensive guides are coming soon.",
    relatedTools: ["business-idea-validator", "business-name-generator", "business-structure-recommender"],
  },
  "business-funding": {
    slug: "business-funding",
    title: "Business Funding",
    metaTitle: "Business Funding Guides",
    metaDescription: "Understand loans, grants, lines of credit, and investors — and how to get funding-ready. Guides and tools from Fairview Systems.",
    intro: "Loans, grants, lines of credit, and investors — learn your options and how to become funding-ready. Detailed guides are on the way.",
    relatedTools: ["business-plan-generator"],
  },
  "contracts-documents": {
    slug: "contracts-documents",
    title: "Contracts & Documents",
    metaTitle: "Business Contracts & Documents",
    metaDescription: "Guides to essential business contracts and documents — what you need, when, and why. From Fairview Systems.",
    intro: "The essential contracts and documents every business needs, explained simply. In-depth guides are coming soon.",
    relatedTools: ["business-structure-recommender"],
  },
};

export const HUB_LIST = Object.values(CONTENT_HUBS).map((h) => ({ slug: h.slug, title: h.title }));
